import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { resetCriteria, selectSelectedIndicatorCount } from '../store/slice'
import classes from './index.module.scss'

export const ClearAll = () => {
  const dispatch = useDispatch()
  const selectedIndicatorCount = useSelector(selectSelectedIndicatorCount)

  const handleClearAll = () => {
    if (!selectedIndicatorCount) return

    dispatch(resetCriteria())
  }

  return (
    <Element
      elementName="span"
      className={classes.headerBtn}
      style={{ color: selectedIndicatorCount ? '' : '#9C9C9C' }}
      onClick={handleClearAll}
    >
      <Translate value="screening.CLEAR_ALL" />
    </Element>
  )
}
